var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "add-maintenance-item-modal",
            "data-toggle": "modal",
            tabindex: "-1",
            role: "dialog",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg modal-dialog-centered",
              staticStyle: { "max-width": "1420px" },
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm.item.plantItemMaintenanceId > 0
                    ? _c(
                        "h5",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "add-maintenance-item-modal-label" },
                        },
                        [_vm._v(_vm._s(_vm.$t("editMaintItem")))]
                      )
                    : _vm._e(),
                  _vm.item.plantItemMaintenanceId === 0
                    ? _c(
                        "h5",
                        {
                          staticClass: "modal-title",
                          attrs: { id: "add-maintenance-item-modal-label" },
                        },
                        [_vm._v(_vm._s(_vm.$t("addMaintItem")))]
                      )
                    : _vm._e(),
                  _vm._m(0),
                ]),
                _c(
                  "div",
                  { staticClass: "modal-body pt-3" },
                  [
                    _vm.loading === true ? _c("loading-spinner") : _vm._e(),
                    _vm.loading === false
                      ? _c("div", { staticClass: "tab-container" }, [
                          _c("ul", { staticClass: "tabs" }, [
                            _c(
                              "li",
                              {
                                class: {
                                  "tab-active": _vm.tabs.item.active === true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTab(_vm.tabs.item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("maintItem")))]
                            ),
                            _c(
                              "li",
                              {
                                class: {
                                  "tab-active":
                                    _vm.tabs.planning.active === true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleTab(_vm.tabs.planning)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("planning")))]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              style: {
                                display:
                                  _vm.tabs.item.active === true
                                    ? "block"
                                    : "none",
                              },
                            },
                            [
                              _c("div", { staticClass: "row mt-3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [_vm._v(_vm._s(_vm.$t("plantItem")))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.plantItemId,
                                            expression: "item.plantItemId",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        class: [
                                          {
                                            "is-invalid":
                                              _vm.getValidateObject(
                                                "plantItemId"
                                              ) ||
                                              _vm.isInputInvalid(
                                                _vm.item.plantItemId,
                                                _vm.plantItemChanged
                                              ),
                                          },
                                        ],
                                        attrs: {
                                          disabled: _vm.item.linked === true,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.item,
                                                "plantItemId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function ($event) {
                                              return _vm.plantItemChange(
                                                _vm.item
                                              )
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.plantItems,
                                        function (plantItem) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: { value: plantItem.id },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(plantItem.name)
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "plantItemId"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("plantItemId"),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group-prepend align-self-start d-flex",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [_vm._v(_vm._s(_vm.$t("category")))]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedCategory,
                                            expression: "selectedCategory",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        class: [
                                          {
                                            "is-invalid":
                                              _vm.getValidateObject("category"),
                                          },
                                        ],
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.selectedCategory = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            function ($event) {
                                              return _vm.categoryChange()
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.maintenanceCategories,
                                        function (category) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: { value: category.id },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(category.name)
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject("category"),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("category"),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _vm.isMaintenanceOpportunityOrRisk
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-4 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("ptRiskNumber"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.item.ptRiskNumber,
                                              expression: "item.ptRiskNumber",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          class: [
                                            {
                                              "is-invalid":
                                                _vm.getValidateObject(
                                                  "ptRiskNumber"
                                                ),
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("ptRiskNumber"),
                                          },
                                          domProps: {
                                            value: _vm.item.ptRiskNumber,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onPtRiskNumberChange()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "ptRiskNumber",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback":
                                                _vm.getValidateObject(
                                                  "ptRiskNumber"
                                                ),
                                            },
                                          },
                                          _vm._l(
                                            _vm.getValidateObject(
                                              "ptRiskNumber"
                                            ),
                                            function (error) {
                                              return _c("span", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.isMaintenanceOpportunityOrRisk
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-4 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("maintenanceId")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.item.maintenanceId,
                                              expression: "item.maintenanceId",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: { type: "text", disabled: "" },
                                          domProps: {
                                            value: _vm.item.maintenanceId,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "maintenanceId",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group-prepend align-self-start d-flex",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("maintenanceActivity")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.maintenanceActivity,
                                            expression:
                                              "item.maintenanceActivity",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        class: [
                                          {
                                            "is-invalid":
                                              _vm.getValidateObject(
                                                "maintenanceActivity"
                                              ) ||
                                              _vm.isInputInvalid(
                                                _vm.item.maintenanceActivity,
                                                _vm.activityItemChanged
                                              ),
                                          },
                                        ],
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.item,
                                                "maintenanceActivity",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function ($event) {
                                              return _vm.maintenanceActivityChange()
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.filteredMaintenanceActivities,
                                        function (maintenanceActivity) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: maintenanceActivity.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(maintenanceActivity.name)
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "maintenanceActivity"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject(
                                          "maintenanceActivity"
                                        ),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-group input-group-sm col-4 mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("maintDescription"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.item.maintenanceDescription,
                                          expression:
                                            "item.maintenanceDescription",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control-sm",
                                      class: [
                                        {
                                          "is-invalid": _vm.getValidateObject(
                                            "maintenanceDescription"
                                          ),
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        disabled: _vm.isPtRiskOrOpportunity(
                                          _vm.item
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.item.maintenanceDescription,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.item,
                                            "maintenanceDescription",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "maintenanceDescription"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject(
                                          "maintenanceDescription"
                                        ),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-group input-group-sm col-4 mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "maintDescriptionLocalLanguage"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.item
                                              .maintenanceDescriptionLocal,
                                          expression:
                                            "item.maintenanceDescriptionLocal",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control-sm",
                                      class: [
                                        {
                                          "is-invalid": _vm.getValidateObject(
                                            "maintenanceDescriptionLocal"
                                          ),
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        disabled: _vm.isPtRiskOrOpportunity(
                                          _vm.item
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.item.maintenanceDescriptionLocal,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.item,
                                            "maintenanceDescriptionLocal",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "maintenanceDescriptionLocal"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject(
                                          "maintenanceDescriptionLocal"
                                        ),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("justification"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.item.justification,
                                          expression: "item.justification",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control-sm",
                                      class: [
                                        {
                                          "is-invalid":
                                            _vm.getValidateObject(
                                              "justification"
                                            ),
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("justification"),
                                      },
                                      domProps: {
                                        value: _vm.item.justification,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.item,
                                            "justification",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "justification"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject("justification"),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm mb-3",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group-prepend align-self-start d-flex",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("maintenanceType"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.maintenanceType,
                                            expression: "item.maintenanceType",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        class: [
                                          {
                                            "is-invalid":
                                              _vm.getValidateObject(
                                                "maintenanceType"
                                              ) ||
                                              _vm.isInputInvalid(
                                                _vm.item.maintenanceType,
                                                _vm.maintenanceTypeChanged,
                                                2
                                              ),
                                          },
                                        ],
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.item,
                                                "maintenanceType",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function ($event) {
                                              return _vm.handleMaintenanceTypeChanged()
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.maintenanceTypes,
                                        function (maintenanceType) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value: maintenanceType.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(maintenanceType.name)
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "invalid-feedback":
                                            _vm.getValidateObject(
                                              "maintenanceType"
                                            ),
                                        },
                                      },
                                      _vm._l(
                                        _vm.getValidateObject(
                                          "maintenanceType"
                                        ),
                                        function (error) {
                                          return _c("span", [
                                            _vm._v(_vm._s(error)),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "col-4 mb-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-group input-group-sm",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [_vm._v(_vm._s(_vm.$t("uel")))]
                                          ),
                                        ]
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.uEL,
                                            expression: "item.uEL",
                                          },
                                        ],
                                        class: [
                                          {
                                            "is-invalid": _vm.isInputInvalid(
                                              _vm.item.uEL,
                                              _vm.uelChanged,
                                              5
                                            ),
                                          },
                                          "form-control form-control-sm",
                                        ],
                                        attrs: {
                                          placeholder: _vm.uelPlaceholder,
                                          type: "number",
                                          min: "0",
                                        },
                                        domProps: { value: _vm.item.uEL },
                                        on: {
                                          change: _vm.onUELChanged,
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.item,
                                              "uEL",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "input-group-text" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("years")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          title: _vm.$t("usefulEconomicLife"),
                                          icon: "info-circle",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "input-info-text" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.uelInfoText) + " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm",
                                  },
                                  [
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.isProject,
                                            expression: "item.isProject",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "isProject",
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.item.isProject,
                                            true
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "isProject",
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("project")) + " "
                                      ),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.isProject,
                                            expression: "item.isProject",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "isProject",
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.item.isProject,
                                            false
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "isProject",
                                              false
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("nonProject")) + " "
                                      ),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm",
                                  },
                                  [
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.isOpex,
                                            expression: "item.isOpex",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "isOpex",
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.item.isOpex,
                                            true
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "isOpex",
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("opex")) + " "
                                      ),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.isOpex,
                                            expression: "item.isOpex",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "isOpex",
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.item.isOpex,
                                            false
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "isOpex",
                                              false
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("capex")) + " "
                                      ),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 input-group input-group-sm",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "radio-label mr-2" },
                                      [_vm._v(_vm._s(_vm.$t("lumpSum")) + ":")]
                                    ),
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.lumpSum,
                                            expression: "item.lumpSum",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "lumpSum",
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(
                                            _vm.item.lumpSum,
                                            true
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "lumpSum",
                                              true
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" " + _vm._s(_vm.$t("yes")) + " "),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                    _c("label", { staticClass: "radio" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.lumpSum,
                                            expression: "item.lumpSum",
                                          },
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "lumpSum",
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(
                                            _vm.item.lumpSum,
                                            false
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.item,
                                              "lumpSum",
                                              false
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" " + _vm._s(_vm.$t("no")) + " "),
                                      _c("span", { staticClass: "checkmark" }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "maintenance-section mt-5" },
                                [
                                  _c("div", { staticClass: "section-title" }, [
                                    _vm._v(_vm._s(_vm.$t("strategy"))),
                                  ]),
                                  _vm.item.maintenanceActivity > 0 &&
                                  _vm.item.plantItemId > 0
                                    ? _c("div", { staticClass: "row mt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 input-group input-group-sm mt-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "radio-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("linked")) + ":"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "label",
                                              { staticClass: "radio" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.item.linked,
                                                      expression: "item.linked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "radio",
                                                    name: "linked",
                                                  },
                                                  domProps: {
                                                    value: true,
                                                    checked: _vm._q(
                                                      _vm.item.linked,
                                                      true
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onLinkedRadioChanged(
                                                        true
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      return _vm.$set(
                                                        _vm.item,
                                                        "linked",
                                                        true
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("yes")) +
                                                    " "
                                                ),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "label",
                                              { staticClass: "radio" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.item.linked,
                                                      expression: "item.linked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "radio",
                                                    name: "linked",
                                                  },
                                                  domProps: {
                                                    value: false,
                                                    checked: _vm._q(
                                                      _vm.item.linked,
                                                      false
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onLinkedRadioChanged(
                                                        false
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      return _vm.$set(
                                                        _vm.item,
                                                        "linked",
                                                        false
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("no")) +
                                                    " "
                                                ),
                                                _c("span", {
                                                  staticClass: "checkmark",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.item.linked === true
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-3 input-group input-group-sm mt-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("groupType")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.maintenanceGroup
                                                            .type,
                                                        expression:
                                                          "maintenanceGroup.type",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "form-control form-control-sm",
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.maintenanceGroup,
                                                            "type",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        function ($event) {
                                                          return _vm.resetMaintenanceGroupItems(
                                                            _vm.item.linked
                                                          )
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.groupTypes,
                                                    function (type) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: type.id,
                                                          domProps: {
                                                            value: type.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(type.name) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isItemLinkedWithSupport
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-3 input-group input-group-sm mt-2",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("plantItem")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.selectedSupportGroupPlantItemId,
                                                        expression:
                                                          "selectedSupportGroupPlantItemId",
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.maintenanceGroup
                                                            .items.length ===
                                                            0 &&
                                                          _vm.isInputInvalid(
                                                            _vm.selectedSupportGroupPlantItemId,
                                                            _vm.selectedSupportGroupPlantItemIdChanged,
                                                            2
                                                          ),
                                                      },
                                                      "form-control form-control-sm",
                                                    ],
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.selectedSupportGroupPlantItemId =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                        function ($event) {
                                                          return _vm.onSupportGroupPlantItemChanged()
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.supportGroupPlantItems,
                                                    function (plantItem) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: plantItem.id,
                                                          domProps: {
                                                            value: plantItem.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                plantItem.plantArea
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                plantItem.name
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.item.linked === true
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group input-group-sm mt-2",
                                                class: {
                                                  "col-6":
                                                    _vm.maintenanceGroup
                                                      .type !==
                                                    _vm.supportGroupType,
                                                  "col-4":
                                                    _vm.maintenanceGroup
                                                      .type ===
                                                    _vm.supportGroupType,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "maintenanceItem"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.pendingItemForAdd,
                                                        expression:
                                                          "pendingItemForAdd",
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.maintenanceGroup
                                                            .items.length ===
                                                            0 &&
                                                          _vm.isInputInvalid(
                                                            _vm.pendingItemForAdd,
                                                            _vm.pendingItemForAddChanged,
                                                            2
                                                          ),
                                                      },
                                                      "form-control form-control-sm",
                                                    ],
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.pendingItemForAdd =
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                        },
                                                        function ($event) {
                                                          return _vm.onMaintenanceItemChanged()
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.itemsFilteredByPlantItem,
                                                    function (item, index) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key:
                                                            "maintenanceItem-" +
                                                            index,
                                                          domProps: {
                                                            value: item,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.maintenanceActivityString
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                item.maintenanceDescription
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.item.linked === true &&
                                        _vm.maintenanceGroup.type !==
                                          _vm.supportGroupType
                                          ? _c(
                                              "div",
                                              { staticClass: "col-1" },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-primary btn-sm mt-2",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addPendingItemToList()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("add")) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  _vm.item.linked === true &&
                                  _vm.maintenanceGroup.type !==
                                    _vm.supportGroupType &&
                                  _vm.item.plantItemId > 0
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 group-header",
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-1" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("position"))
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-6" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("item"))
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm.maintenanceGroup.type ===
                                              _vm.alternateGroupType
                                                ? _c(
                                                    "div",
                                                    { staticClass: "col-1" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("driver")
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.maintenanceGroup.type ===
                                              _vm.alternateGroupType
                                                ? _c(
                                                    "div",
                                                    { staticClass: "col-1" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("tolerance")
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.maintenanceGroup.type ===
                                              _vm.alternateGroupType
                                                ? _c(
                                                    "div",
                                                    { staticClass: "col-2" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("interval")
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item.linked === true &&
                                  _vm.maintenanceGroup.type !==
                                    _vm.supportGroupType &&
                                  _vm.item.plantItemId > 0 &&
                                  _vm.item.maintenanceActivity > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row maintenance-drop-area",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-12 drop-target",
                                              attrs: {
                                                "drop-over": _vm.isDragActive,
                                                id: "dropTarget",
                                              },
                                              on: {
                                                dragstart: function ($event) {
                                                  return _vm.dragStarted()
                                                },
                                                dragend: function ($event) {
                                                  return _vm.dragEnded()
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.maintenanceGroup.items,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: "linkedItem-" + index,
                                                    staticClass:
                                                      "row maintenance-item",
                                                    class: [
                                                      {
                                                        "already-assigned":
                                                          item.alreadyAssigned,
                                                      },
                                                      {
                                                        active:
                                                          _vm.dragPosition ===
                                                          index,
                                                      },
                                                    ],
                                                    attrs: {
                                                      draggable: "true",
                                                    },
                                                    on: {
                                                      dragstart: function (
                                                        $event
                                                      ) {
                                                        return _vm.drag(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                      dragover: function (
                                                        $event
                                                      ) {
                                                        return _vm.allowDrop(
                                                          $event
                                                        )
                                                      },
                                                      dragenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleDragEnter(
                                                          $event,
                                                          index
                                                        )
                                                      },
                                                      drop: function ($event) {
                                                        return _vm.drop($event)
                                                      },
                                                      dragend: function (
                                                        $event
                                                      ) {
                                                        return _vm.dragEnd(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-1" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.position + 1
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "col-6":
                                                            _vm.maintenanceGroup
                                                              .type ===
                                                            _vm.alternateGroupType,
                                                          "col-10":
                                                            _vm.maintenanceGroup
                                                              .type !==
                                                            _vm.alternateGroupType,
                                                        },
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.maintenanceActivityString
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                item.maintenanceDescription
                                                              ) +
                                                              " "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm.maintenanceGroup
                                                      .type ===
                                                    _vm.alternateGroupType
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-1 text-truncate pr-0",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.driver
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.maintenanceGroup
                                                      .type ===
                                                    _vm.alternateGroupType
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.tolerance
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.maintenanceGroup
                                                      .type ===
                                                    _vm.alternateGroupType
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    item.interval,
                                                                  expression:
                                                                    "item.interval",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control form-control-sm",
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.interval,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      item,
                                                                      "interval",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-1" },
                                                      [
                                                        _c("pui-icon", {
                                                          staticClass:
                                                            "delete-item",
                                                          attrs: {
                                                            "icon-name":
                                                              "icon-close",
                                                          },
                                                          nativeOn: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeLinkedMaintenanceItem(
                                                                item.position
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    item.driver2 &&
                                                    _vm.maintenanceGroup
                                                      .type ===
                                                      _vm.alternateGroupType
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-1 offset-7",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.driver2
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.tolerance2
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-2",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      item.interval2,
                                                                    expression:
                                                                      "item.interval2",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control-sm",
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    item.interval2,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        item,
                                                                        "interval2",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isItemLinkedWithSupport &&
                                  _vm.item.plantItemId > 0
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 group-header",
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-2" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("itemType"))
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-10" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("item"))
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.isItemLinkedWithSupport &&
                                  _vm.item.plantItemId > 0 &&
                                  _vm.item.maintenanceActivity > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row maintenance-drop-area",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-12 drop-target",
                                            },
                                            _vm._l(
                                              _vm.maintenanceGroup.items,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row maintenance-item",
                                                    class: {
                                                      "already-assigned":
                                                        item.alreadyAssigned,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-2" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.position ===
                                                                0
                                                                ? _vm.$t(
                                                                    "mainActivity"
                                                                  )
                                                                : _vm.$t(
                                                                    "supportActivity"
                                                                  )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-10" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.plantArea
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              _vm.getPlantItemName(
                                                                item.plantItemId
                                                              )
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              item.maintenanceActivityString
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              item.maintenanceDescription
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 input-group input-group-sm mb-3",
                                        class: {
                                          "mt-3":
                                            _vm.item.maintenance === 0 ||
                                            _vm.item.plantItemId === 0,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [_vm._v(_vm._s(_vm.$t("driver")))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.item.driver,
                                                expression: "item.driver",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "driver"
                                                  ) ||
                                                  _vm.isInputInvalid(
                                                    _vm.item.driver,
                                                    _vm.driverItemChanged
                                                  ),
                                              },
                                            ],
                                            attrs: {
                                              disabled:
                                                _vm.isItemLinkedWithSupport,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.item,
                                                    "driver",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                                function ($event) {
                                                  return _vm.setDriver(false)
                                                },
                                              ],
                                            },
                                          },
                                          _vm._l(
                                            _vm.firstDrivers,
                                            function (driver) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: driver.id,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(driver.name)
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm.item.driver !== _vm.driverTypes.Once
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [_vm._v("X2")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.secondDriver,
                                                          expression:
                                                            "secondDriver",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        "aria-label":
                                                          _vm.$t(
                                                            "secondDriver"
                                                          ),
                                                        disabled:
                                                          _vm.isItemLinkedWithSupport,
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.secondDriver
                                                        )
                                                          ? _vm._i(
                                                              _vm.secondDriver,
                                                              null
                                                            ) > -1
                                                          : _vm.secondDriver,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.secondDriver,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.secondDriver =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.secondDriver =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.secondDriver =
                                                              $$c
                                                          }
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback":
                                                _vm.getValidateObject("driver"),
                                            },
                                          },
                                          _vm._l(
                                            _vm.getValidateObject("driver"),
                                            function (error) {
                                              return _c("span", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm.item.driver === _vm.driverTypes.EOH &&
                                  _vm.item.itemModel === _vm.modelTypes.Custom
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mb-3" },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(_vm.$t("formula")) +
                                                  ": EOH = OH + (K1 * nh + K2 * nw + K3 * nc)"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item.driver === _vm.driverTypes.EOH &&
                                  _vm.item.itemModel ===
                                    _vm.modelTypes["VGB_Generator"]
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mb-3" },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(_vm.$t("formula")) +
                                                  ": EOH = OH + Kb * BOH + Kg * ns"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item.driver ===
                                    _vm.driverTypes["LTE/Ageing"] &&
                                  _vm.item.itemModel === _vm.modelTypes.Custom
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mb-3" },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(_vm.$t("formula")) +
                                                  ": LTE/Aging = (Ez * OH + En * (K1 * nh + K2 * nw + K3 * nc)) / Ks"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item.driver === _vm.driverTypes.EOH &&
                                  _vm.item.itemModel ===
                                    _vm.modelTypes.Direct_DCS_Value
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mb-3" },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dcsFormulaExplained")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item.driver === _vm.driverTypes["OH"] &&
                                  _vm.item.itemModel ===
                                    _vm.modelTypes["Linked_with_OH"]
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mb-3" },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                _vm._s(_vm.$t("formula")) +
                                                  ": DtD = (DtDr * (1 - " +
                                                  _vm._s(
                                                    _vm.$t("linkedWithOH")
                                                  ) +
                                                  " ))+(( DtDr * " +
                                                  _vm._s(
                                                    _vm.$t("linkedWithOH")
                                                  ) +
                                                  ") / OHr) * OH"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-12" }, [
                                      _vm.item.driver > 0 &&
                                      (_vm.item.driver !== _vm.driverTypes.OH ||
                                        (_vm.item.driver ==
                                          _vm.driverTypes.OH &&
                                          _vm.item.maintenanceActivity ==
                                            _vm.maintenanceActivitiesEnum[
                                              "Day_To_Day_Maintenance"
                                            ])) &&
                                      _vm.drivers.find(function (x) {
                                        return x.id === _vm.item.driver
                                      }).models.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group input-group-sm mb-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-12 input-group input-group-sm",
                                                  staticStyle: { padding: "0" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("model")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.item.itemModel,
                                                          expression:
                                                            "item.itemModel",
                                                        },
                                                      ],
                                                      class: [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "model"
                                                            ) ||
                                                            _vm.isInputInvalid(
                                                              _vm.item
                                                                .itemModel,
                                                              _vm.modelItemChanged
                                                            ),
                                                        },
                                                        "form-control form-control-sm",
                                                      ],
                                                      attrs: {
                                                        disabled:
                                                          _vm.isItemLinkedWithSupport,
                                                      },
                                                      on: {
                                                        change: [
                                                          function ($event) {
                                                            var $$selectedVal =
                                                              Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function (o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function (
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                            _vm.$set(
                                                              _vm.item,
                                                              "itemModel",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function ($event) {
                                                            return _vm.setModel()
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.drivers.find(
                                                        function (x) {
                                                          return (
                                                            x.id ===
                                                            _vm.item.driver
                                                          )
                                                        }
                                                      ).models,
                                                      function (model) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key:
                                                              "model1-" +
                                                              model.id,
                                                            domProps: {
                                                              value: model.id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(model.name)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "model"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "model"
                                                      ),
                                                      function (error, index) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key:
                                                              "modelError-" +
                                                              index,
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(error) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _vm.item.driver ===
                                                _vm.driverTypes.EOH &&
                                              _vm.item.itemModel ===
                                                _vm.modelTypes["VGB_Generator"]
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group input-group-sm",
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.initializeTooltips()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width mt-3",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(1),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .s,
                                                                    expression:
                                                                      "item.customInputs.s",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control-sm",
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.s"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .s,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .s,
                                                                        1
                                                                      ),
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .s,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "s"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "s",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _vm._m(2),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "apparentPowerMva"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.s"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.s"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "linkedWithOhBOH"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .linkedWithOH,
                                                                    expression:
                                                                      "item.customInputs.linkedWithOH",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control form-control-sm",
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.linkedWithOH"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .linkedWithOH,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .linkedWithOH,
                                                                        3
                                                                      ),
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  step: "1",
                                                                  max: "100",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .linkedWithOH,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "linkedWithOH"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "linkedWithOH",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _vm._m(3),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "bohOhFactor"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.linkedWithOH"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.linkedWithOH"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6",
                                                            },
                                                            [
                                                              _c("i", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "formula"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "kbBarringCoefficient"
                                                                      )
                                                                    ) +
                                                                    " = 1 / 4000 * S + 0,2"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6",
                                                            },
                                                            [
                                                              _c("i", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "formula"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "bearingOHFormula"
                                                                      )
                                                                    ) +
                                                                    " (BOH) = " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "factor"
                                                                      )
                                                                    ) +
                                                                    " * OH"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.item.driver ===
                                                _vm.driverTypes.OH &&
                                              _vm.item.itemModel ===
                                                _vm.modelTypes["Linked_with_OH"]
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group input-group-sm",
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.initializeTooltips()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width mt-3",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(4),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .dtDr,
                                                                    expression:
                                                                      "item.customInputs.dtDr",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.DtDr"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .dtDr,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .dtDr,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .dtDr,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "dtDr"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "dtDr",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.DtDr"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.DtDr"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(5),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .oHr,
                                                                    expression:
                                                                      "item.customInputs.oHr",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.OHr"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .oHr,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .oHr,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .oHr,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "oHr"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "oHr",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.OHr"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.OHr"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 input-group input-group-sm",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "linkedWithOH"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .linkedWithOH,
                                                                    expression:
                                                                      "item.customInputs.linkedWithOH",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.LinkedWithOH"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .linkedWithOH,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .linkedWithOH,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .linkedWithOH,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "linkedWithOH"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "linkedWithOH",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.LinkedWithOH"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.LinkedWithOH"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.item.driver ===
                                                _vm.driverTypes.EOH &&
                                              _vm.item.itemModel ===
                                                _vm.modelTypes.Custom
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group input-group-sm",
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.initializeTooltips()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width mt-3",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(6),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k1,
                                                                    expression:
                                                                      "item.customInputs.k1",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k1,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k1,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k1,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k1"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k1",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K1"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "hotStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(7),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k2,
                                                                    expression:
                                                                      "item.customInputs.k2",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k2,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k2,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k2,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k2"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k2",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K2"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "warmStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm",
                                                            },
                                                            [
                                                              _vm._m(8),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k3,
                                                                    expression:
                                                                      "item.customInputs.k3",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k3,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k3,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k3,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k3"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k3",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K3"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "coldStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.item.driver ===
                                                _vm.driverTypes["LTE/Ageing"] &&
                                              _vm.item.itemModel ===
                                                _vm.modelTypes.Custom
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group input-group-sm",
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.initializeTooltips()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row mt-3 full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(9),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .ez,
                                                                    expression:
                                                                      "item.customInputs.ez",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ez"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .ez,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .ez,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .ez,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "ez"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "ez",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ez"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.Ez"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "coefficientPerOH"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(10),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .en,
                                                                    expression:
                                                                      "item.customInputs.en",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.En"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .en,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .en,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .en,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "en"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "en",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.En"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.En"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "coefficientPerStarts"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(11),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .ks,
                                                                    expression:
                                                                      "item.customInputs.ks",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ks"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .ks,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .ks,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .ks,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "ks"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "ks",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ks"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.Ks"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "securityFactor"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm mb-3",
                                                            },
                                                            [
                                                              _vm._m(12),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k1,
                                                                    expression:
                                                                      "item.customInputs.k1",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k1,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k1,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k1,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k1"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k1",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K1"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "hotStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row full-width",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm",
                                                            },
                                                            [
                                                              _vm._m(13),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k2,
                                                                    expression:
                                                                      "item.customInputs.k2",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k2,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k2,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k2,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k2"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k2",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K2"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "warmStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-6 input-group input-group-sm",
                                                            },
                                                            [
                                                              _vm._m(14),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      _vm.item
                                                                        .customInputs
                                                                        .k3,
                                                                    expression:
                                                                      "item.customInputs.k3",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ) ||
                                                                      _vm.isInputInvalid(
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k3,
                                                                        _vm
                                                                          .customInputChanged
                                                                          .k3,
                                                                        2
                                                                      ),
                                                                  },
                                                                  "form-control form-control-sm",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  disabled:
                                                                    _vm.isItemLinkedWithSupport,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.item
                                                                      .customInputs
                                                                      .k3,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleCustomInputChanged(
                                                                        "k3"
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm.item
                                                                          .customInputs,
                                                                        "k3",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "customInputs.K3"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "info-circle",
                                                                    "data-toggle":
                                                                      "tooltip",
                                                                    "data-placement":
                                                                      "top",
                                                                    title:
                                                                      _vm.$t(
                                                                        "coldStartsPenalty"
                                                                      ),
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group input-group-sm mb-3",
                                        class: [
                                          {
                                            "col-6": !_vm.shouldShowPleLimit(
                                              _vm.item.kksCode,
                                              _vm.item.driver
                                            ),
                                          },
                                          {
                                            "col-3": _vm.shouldShowPleLimit(
                                              _vm.item.kksCode,
                                              _vm.item.driver
                                            ),
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _vm.item.driver !==
                                              _vm.driverTypes.Once &&
                                            _vm.item.driver !==
                                              _vm.driverTypes.Condition_Based
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("interval"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.item.driver ===
                                              _vm.driverTypes.Once ||
                                            _vm.item.driver ===
                                              _vm.driverTypes.Condition_Based
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("date"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.item.driver !==
                                          _vm.driverTypes.Once &&
                                        _vm.item.driver !==
                                          _vm.driverTypes.Condition_Based
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.item.interval,
                                                  expression: "item.interval",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              class: [
                                                {
                                                  "is-invalid":
                                                    _vm.getValidateObject(
                                                      "interval"
                                                    ) ||
                                                    _vm.isInputInvalid(
                                                      _vm.item.interval,
                                                      _vm.intervalItemChanged,
                                                      1
                                                    ),
                                                },
                                                "form-control",
                                              ],
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                disabled:
                                                  _vm.isItemLinkedWithSupport,
                                              },
                                              domProps: {
                                                value: _vm.item.interval,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.handleIntervalChanged()
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.item,
                                                    "interval",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.item.driver ===
                                          _vm.driverTypes.Once ||
                                        _vm.item.driver ===
                                          _vm.driverTypes.Condition_Based
                                          ? _c("date-picker", {
                                              attrs: {
                                                type: "date",
                                                "value-type": "format",
                                                format: "YYYY-MM-DD",
                                                disabled:
                                                  _vm.isItemLinkedWithSupport,
                                                "input-class": [
                                                  {
                                                    "is-invalid":
                                                      _vm.getValidateObject(
                                                        "interval"
                                                      ) ||
                                                      _vm.isInputInvalid(
                                                        _vm.onceDriverDate,
                                                        _vm.conditionalDateChanged
                                                      ),
                                                  },
                                                  "form-control form-control-sm",
                                                ],
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onceDriverDateChange(
                                                    _vm.onceDriverDate
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.onceDriverDate,
                                                callback: function ($$v) {
                                                  _vm.onceDriverDate = $$v
                                                },
                                                expression: "onceDriverDate",
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "input-group-append" },
                                          [
                                            _vm.displayHours(_vm.item)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("hours")) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.item.driver ===
                                            _vm.driverTypes.Years
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("years"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.item.driver ===
                                            _vm.driverTypes.Months
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("months"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.item.driver ===
                                            _vm.driverTypes.Starts
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("starts"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.item.driver ===
                                              _vm.driverTypes.Once ||
                                            _vm.item.driver ===
                                              _vm.driverTypes.Conditin_Based
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("date"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm.getValidateObject("interval")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "invalid-feedback d-block",
                                              },
                                              _vm._l(
                                                _vm.getValidateObject(
                                                  "interval"
                                                ),
                                                function (error) {
                                                  return _c("span", [
                                                    _vm._v(_vm._s(error)),
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm.shouldShowPleLimit(
                                      _vm.item.kksCode,
                                      _vm.item.driver
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-3 input-group input-group-sm mb-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("ple50Limit")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.item.p50Limit,
                                                  expression: "item.p50Limit",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              class: [
                                                {
                                                  "is-invalid":
                                                    _vm.getValidateObject(
                                                      "p50Limit"
                                                    ),
                                                },
                                                "form-control",
                                              ],
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                disabled:
                                                  _vm.isItemLinkedWithSupport,
                                              },
                                              domProps: {
                                                value: _vm.item.p50Limit,
                                              },
                                              on: {
                                                blur: [
                                                  function ($event) {
                                                    return _vm.handleInputEmptyStringNumber(
                                                      _vm.item
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                ],
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.item,
                                                    "p50Limit",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append",
                                              },
                                              [
                                                _vm.displayHours(_vm.item)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("hours")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver ===
                                                _vm.driverTypes.Starts
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("starts")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.getValidateObject("p50Limit")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback d-block",
                                                  },
                                                  _vm._l(
                                                    _vm.getValidateObject(
                                                      "p50Limit"
                                                    ),
                                                    function (error) {
                                                      return _c("span", [
                                                        _vm._v(_vm._s(error)),
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.shouldShowPleLimit(
                                      _vm.item.kksCode,
                                      _vm.item.driver
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-3 input-group input-group-sm mb-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("ple80Limit")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.item.p80Limit,
                                                  expression: "item.p80Limit",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              class: [
                                                {
                                                  "is-invalid":
                                                    _vm.getValidateObject(
                                                      "p80Limit"
                                                    ),
                                                },
                                                "form-control",
                                              ],
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                disabled:
                                                  _vm.isItemLinkedWithSupport,
                                              },
                                              domProps: {
                                                value: _vm.item.p80Limit,
                                              },
                                              on: {
                                                blur: [
                                                  function ($event) {
                                                    return _vm.handleInputEmptyStringNumber(
                                                      _vm.item
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                ],
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.item,
                                                    "p80Limit",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append",
                                              },
                                              [
                                                _vm.displayHours(_vm.item)
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("hours")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver ===
                                                _vm.driverTypes.Starts
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("starts")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.getValidateObject("p80Limit")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback d-block",
                                                  },
                                                  _vm._l(
                                                    _vm.getValidateObject(
                                                      "p80Limit"
                                                    ),
                                                    function (error) {
                                                      return _c("span", [
                                                        _vm._v(_vm._s(error)),
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-group input-group-sm mb-3",
                                        class: [
                                          {
                                            "col-6": !_vm.shouldShowPleLimit(
                                              _vm.item.kksCode,
                                              _vm.item.driver
                                            ),
                                          },
                                          {
                                            "col-3": _vm.shouldShowPleLimit(
                                              _vm.item.kksCode,
                                              _vm.item.driver
                                            ),
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("tolerance"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.item.tolerance,
                                              expression: "item.tolerance",
                                              modifiers: { number: true },
                                            },
                                          ],
                                          class: [
                                            {
                                              "is-invalid":
                                                _vm.getValidateObject(
                                                  "tolerance"
                                                ) ||
                                                _vm.isInputInvalid(
                                                  _vm.item.tolerance,
                                                  _vm.toleranceItemChanged,
                                                  3
                                                ),
                                            },
                                            "form-control",
                                          ],
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            disabled:
                                              _vm.isItemLinkedWithSupport,
                                          },
                                          domProps: {
                                            value: _vm.item.tolerance,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleToleranceChanged()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "tolerance",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                        _vm._m(15),
                                        _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback":
                                                _vm.getValidateObject(
                                                  "tolerance"
                                                ),
                                            },
                                          },
                                          _vm._l(
                                            _vm.getValidateObject("tolerance"),
                                            function (error) {
                                              return _c("span", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.secondDriver,
                                          expression: "secondDriver",
                                        },
                                      ],
                                      staticClass: "mb-3 pt-3",
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 input-group input-group-sm mb-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("secondDriver")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.item.driver2,
                                                    expression: "item.driver2",
                                                  },
                                                ],
                                                class: [
                                                  {
                                                    "is-invalid":
                                                      _vm.getValidateObject(
                                                        "driver2"
                                                      ) ||
                                                      _vm.isInputInvalid(
                                                        _vm.item.driver2,
                                                        _vm.driver2ItemChanged
                                                      ),
                                                  },
                                                  "form-control form-control-sm",
                                                ],
                                                attrs: {
                                                  disabled:
                                                    _vm.isItemLinkedWithSupport,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.item,
                                                        "driver2",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function ($event) {
                                                      return _vm.setDriver(true)
                                                    },
                                                  ],
                                                },
                                              },
                                              _vm._l(
                                                _vm.secondDrivers,
                                                function (driver) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: driver.id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(driver.name)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _c(
                                              "div",
                                              {
                                                class: {
                                                  "invalid-feedback":
                                                    _vm.getValidateObject(
                                                      "driver2"
                                                    ),
                                                },
                                              },
                                              _vm._l(
                                                _vm.getValidateObject(
                                                  "driver2"
                                                ),
                                                function (error) {
                                                  return _c("span", [
                                                    _vm._v(_vm._s(error)),
                                                  ])
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm.item.driver2 ===
                                        _vm.driverTypes.EOH &&
                                      _vm.item.model2 ===
                                        _vm.modelTypes["VGB_Generator"]
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-12 mb-3" },
                                              [
                                                _c("i", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("formula")) +
                                                      ": EOH = OH + Kb * BOH + Kg * ns"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.item.driver2 ===
                                        _vm.driverTypes["LTE/Ageing"] &&
                                      _vm.item.model2 === _vm.modelTypes.Custom
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-12 mb-3" },
                                              [
                                                _c("i", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("formula")) +
                                                      ": LTE/Aging = (Ez * OH + En * (K1 * nh + K2 * nw + K3 * nc)) / Ks"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.item.driver2 ===
                                        _vm.driverTypes["OH"] &&
                                      _vm.item.model2 ===
                                        _vm.modelTypes["Linked_with_OH"]
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-12 mb-3" },
                                              [
                                                _c("i", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("formula")) +
                                                      ": DtD = (DtDr * (1 - " +
                                                      _vm._s(
                                                        _vm.$t("linkedWithOH")
                                                      ) +
                                                      " ))+(( DtDr * " +
                                                      _vm._s(
                                                        _vm.$t("linkedWithOH")
                                                      ) +
                                                      ") / OHr) * OH"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-12" }, [
                                          _vm.item.driver2 > 0 &&
                                          _vm.item.driver2 !==
                                            _vm.driverTypes.OH &&
                                          _vm.drivers.find(function (x) {
                                            return x.id === _vm.item.driver2
                                          }).models.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 input-group input-group-sm",
                                                      staticStyle: {
                                                        padding: "0",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "input-group-text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "model"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.item.model2,
                                                              expression:
                                                                "item.model2",
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "model2"
                                                                ) ||
                                                                _vm.isInputInvalid(
                                                                  _vm.item
                                                                    .model2,
                                                                  _vm.model2ItemChanged
                                                                ),
                                                            },
                                                            "form-control form-control-sm",
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.isItemLinkedWithSupport,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  _vm.item,
                                                                  "model2",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.setModel(
                                                                  true
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.secondDriverModels,
                                                          function (model) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key:
                                                                  "model2-" +
                                                                  model.id,
                                                                domProps: {
                                                                  value:
                                                                    model.id,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    model.name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "invalid-feedback":
                                                              _vm.getValidateObject(
                                                                "model2"
                                                              ),
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.getValidateObject(
                                                            "model2"
                                                          ),
                                                          function (
                                                            error,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "model2Error-" +
                                                                  index,
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      error
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.item.driver2 ===
                                                    _vm.driverTypes.EOH &&
                                                  _vm.item.model2 ===
                                                    _vm.modelTypes[
                                                      "VGB_Generator"
                                                    ]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm",
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.initializeTooltips()
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width mt-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(16),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .s,
                                                                          expression:
                                                                            "item.customInputs.s",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.s"
                                                                          ),
                                                                      } ||
                                                                        _vm.isInputInvalid(
                                                                          _vm
                                                                            .item
                                                                            .customInputs
                                                                            .s,
                                                                          _vm
                                                                            .customInputChanged
                                                                            .s,
                                                                          1
                                                                        ),
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .s,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "s"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "s",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _vm._m(17),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "apparentPowerMva"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.s"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.s"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "linkedWithOhBOH"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .linkedWithOH,
                                                                          expression:
                                                                            "item.customInputs.linkedWithOH",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.linkedWithOH"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .linkedWithOH,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .linkedWithOH,
                                                                            3
                                                                          ),
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      max: "100",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .linkedWithOH,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "linkedWithOH"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "linkedWithOH",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _vm._m(18),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "bohOhFactor"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.linkedWithOH"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.linkedWithOH"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width",
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "col-6",
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6",
                                                                },
                                                                [
                                                                  _c("i", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "formula"
                                                                        )
                                                                      ) +
                                                                        ": BOH = " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "factor"
                                                                          )
                                                                        ) +
                                                                        " * OH"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.item.driver2 ===
                                                    _vm.driverTypes.OH &&
                                                  _vm.item.model2 ===
                                                    _vm.modelTypes[
                                                      "Linked_with_OH"
                                                    ]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm",
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.initializeTooltips()
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width mt-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(19),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .dtDr,
                                                                          expression:
                                                                            "item.customInputs.dtDr",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.DtDr"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .dtDr,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .dtDr,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .dtDr,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "dtDr"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "dtDr",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.DtDr"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.DtDr"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(20),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .oHr,
                                                                          expression:
                                                                            "item.customInputs.oHr",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.OHr"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .oHr,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .oHr,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .oHr,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "oHr"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "oHr",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.OHr"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.OHr"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-12 input-group input-group-sm",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "linkedWithOH"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .linkedWithOH,
                                                                          expression:
                                                                            "item.customInputs.linkedWithOH",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.LinkedWithOH"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .linkedWithOH,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .linkedWithOH,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .linkedWithOH,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "linkedWithOH"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "linkedWithOH",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.LinkedWithOH"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.LinkedWithOH"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.item.driver2 ===
                                                    _vm.driverTypes.EOH &&
                                                  _vm.item.model2 ===
                                                    _vm.modelTypes.Custom
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm",
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.initializeTooltips()
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width mt-3",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(21),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k1,
                                                                          expression:
                                                                            "item.customInputs.k1",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K1"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k1,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k1,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k1,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k1"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k1",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K1"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "hotStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(22),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k2,
                                                                          expression:
                                                                            "item.customInputs.k2",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K2"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k2,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k2,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k2,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k2"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k2",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K2"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "warmStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm",
                                                                },
                                                                [
                                                                  _vm._m(23),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k3,
                                                                          expression:
                                                                            "item.customInputs.k3",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K3"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k3,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k3,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k3,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k3"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k3",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K3"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "coldStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.item.driver2 ===
                                                    _vm.driverTypes[
                                                      "LTE/Ageing"
                                                    ] &&
                                                  _vm.item.model2 ===
                                                    _vm.modelTypes.Custom
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group input-group-sm",
                                                          on: {
                                                            mouseenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.initializeTooltips()
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row mt-3 full-width",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(24),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .ez,
                                                                          expression:
                                                                            "item.customInputs.ez",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.Ez"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .ez,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .ez,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .ez,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "ez"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "ez",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.Ez"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ez"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "coefficientPerOH"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(25),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .en,
                                                                          expression:
                                                                            "item.customInputs.en",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.En"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .en,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .en,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .en,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "en"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "en",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.En"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.En"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "coefficientPerStarts"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(26),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .ks,
                                                                          expression:
                                                                            "item.customInputs.ks",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.Ks"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .ks,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .ks,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .ks,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "ks"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "ks",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.Ks"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.Ks"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "securityFactor"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm mb-3",
                                                                },
                                                                [
                                                                  _vm._m(27),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k1,
                                                                          expression:
                                                                            "item.customInputs.k1",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K1"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k1,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k1,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k1,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k1"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k1",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K1"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K1"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "hotStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row full-width",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm",
                                                                },
                                                                [
                                                                  _vm._m(28),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k2,
                                                                          expression:
                                                                            "item.customInputs.k2",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K2"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k2,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k2,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k2,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k2"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k2",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K2"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K2"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "warmStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-6 input-group input-group-sm",
                                                                },
                                                                [
                                                                  _vm._m(29),
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k3,
                                                                          expression:
                                                                            "item.customInputs.k3",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K3"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            _vm
                                                                              .item
                                                                              .customInputs
                                                                              .k3,
                                                                            _vm
                                                                              .customInputChanged
                                                                              .k3,
                                                                            2
                                                                          ),
                                                                      },
                                                                      "form-control form-control-sm",
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        _vm.isItemLinkedWithSupport,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.item
                                                                          .customInputs
                                                                          .k3,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.handleCustomInputChanged(
                                                                            "k3"
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customInputs,
                                                                            "k3",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "customInputs.K3"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "customInputs.K3"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                error
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _c(
                                                                    "font-awesome-icon",
                                                                    {
                                                                      attrs: {
                                                                        icon: "info-circle",
                                                                        "data-toggle":
                                                                          "tooltip",
                                                                        "data-placement":
                                                                          "top",
                                                                        title:
                                                                          _vm.$t(
                                                                            "coldStartsPenalty"
                                                                          ),
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-group input-group-sm mb-3",
                                            class: [
                                              {
                                                "col-6":
                                                  !_vm.shouldShowPleLimit(
                                                    _vm.item.kksCode,
                                                    _vm.item.driver2
                                                  ),
                                              },
                                              {
                                                "col-3": _vm.shouldShowPleLimit(
                                                  _vm.item.kksCode,
                                                  _vm.item.driver2
                                                ),
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend",
                                              },
                                              [
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes.Once &&
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes
                                                    .Condition_Based
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("interval")
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver2 ===
                                                  _vm.driverTypes.Once ||
                                                _vm.item.driver2 ===
                                                  _vm.driverTypes
                                                    .Condition_Based
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("date"))
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.item.driver2 !==
                                              _vm.driverTypes.Once &&
                                            _vm.item.driver2 !==
                                              _vm.driverTypes.Condition_Based
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.item.interval2,
                                                      expression:
                                                        "item.interval2",
                                                      modifiers: {
                                                        number: true,
                                                      },
                                                    },
                                                  ],
                                                  class: [
                                                    {
                                                      "is-invalid":
                                                        _vm.getValidateObject(
                                                          "interval2"
                                                        ) ||
                                                        _vm.isInputInvalid(
                                                          _vm.item.interval2,
                                                          _vm.interval2ItemChanged,
                                                          1
                                                        ),
                                                    },
                                                    "form-control",
                                                  ],
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    disabled:
                                                      _vm.isItemLinkedWithSupport,
                                                  },
                                                  domProps: {
                                                    value: _vm.item.interval2,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleIntervalChanged(
                                                        true
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.item,
                                                        "interval2",
                                                        _vm._n(
                                                          $event.target.value
                                                        )
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.item.driver2 ===
                                              _vm.driverTypes.Once ||
                                            _vm.item.driver2 ===
                                              _vm.driverTypes.Condition_Based
                                              ? _c("date-picker", {
                                                  attrs: {
                                                    type: "date",
                                                    "value-type": "format",
                                                    format: "YYYY-MM-DD",
                                                    disabled:
                                                      _vm.isItemLinkedWithSupport,
                                                    "input-class": [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "interval2"
                                                          ) ||
                                                          _vm.isInputInvalid(
                                                            _vm.onceDriverDate2,
                                                            _vm.conditionalDate2Changed
                                                          ),
                                                      },
                                                      "form-control form-control-sm",
                                                    ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.onceDriverDateChange(
                                                        _vm.onceDriverDate2,
                                                        true
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.onceDriverDate2,
                                                    callback: function ($$v) {
                                                      _vm.onceDriverDate2 = $$v
                                                    },
                                                    expression:
                                                      "onceDriverDate2",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-append",
                                              },
                                              [
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes.Years &&
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes.Starts &&
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes.Once &&
                                                _vm.item.driver2 !==
                                                  _vm.driverTypes
                                                    .Condition_Based
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("hours")
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver2 ===
                                                _vm.driverTypes.Years
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("years")
                                                            )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver2 ===
                                                _vm.driverTypes.Starts
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("starts")
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.item.driver2 ===
                                                  _vm.driverTypes.Once ||
                                                _vm.item.driver2 ===
                                                  _vm.driverTypes
                                                    .Condition_Based
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("date"))
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.getValidateObject("interval2")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback d-block",
                                                  },
                                                  _vm._l(
                                                    _vm.getValidateObject(
                                                      "interval2"
                                                    ),
                                                    function (error) {
                                                      return _c("span", [
                                                        _vm._v(_vm._s(error)),
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.shouldShowPleLimit(
                                          _vm.item.kksCode,
                                          _vm.item.driver2
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-3 input-group input-group-sm mb-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("ple50Limit")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.item.p50Limit2,
                                                      expression:
                                                        "item.p50Limit2",
                                                      modifiers: {
                                                        number: true,
                                                      },
                                                    },
                                                  ],
                                                  class: [
                                                    {
                                                      "is-invalid":
                                                        _vm.getValidateObject(
                                                          "p50Limit2"
                                                        ),
                                                    },
                                                    "form-control",
                                                  ],
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    disabled:
                                                      _vm.isItemLinkedWithSupport,
                                                  },
                                                  domProps: {
                                                    value: _vm.item.p50Limit2,
                                                  },
                                                  on: {
                                                    blur: [
                                                      function ($event) {
                                                        return _vm.handleInputEmptyStringNumber(
                                                          _vm.item
                                                        )
                                                      },
                                                      function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    ],
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.item,
                                                        "p50Limit2",
                                                        _vm._n(
                                                          $event.target.value
                                                        )
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-append",
                                                  },
                                                  [
                                                    _vm.item.driver2 ===
                                                    _vm.driverTypes.Starts
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("starts")
                                                              ) + " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("hours")
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm.getValidateObject(
                                                  "p50Limit2"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback d-block",
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "p50Limit2"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.shouldShowPleLimit(
                                          _vm.item.kksCode,
                                          _vm.item.driver2
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-3 input-group input-group-sm mb-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-prepend",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "input-group-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("ple80Limit")
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.item.p80Limit2,
                                                      expression:
                                                        "item.p80Limit2",
                                                      modifiers: {
                                                        number: true,
                                                      },
                                                    },
                                                  ],
                                                  class: [
                                                    {
                                                      "is-invalid":
                                                        _vm.getValidateObject(
                                                          "p80Limit2"
                                                        ),
                                                    },
                                                    "form-control",
                                                  ],
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    disabled:
                                                      _vm.isItemLinkedWithSupport,
                                                  },
                                                  domProps: {
                                                    value: _vm.item.p80Limit2,
                                                  },
                                                  on: {
                                                    blur: [
                                                      function ($event) {
                                                        return _vm.handleInputEmptyStringNumber(
                                                          _vm.item
                                                        )
                                                      },
                                                      function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    ],
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.item,
                                                        "p80Limit2",
                                                        _vm._n(
                                                          $event.target.value
                                                        )
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-append",
                                                  },
                                                  [
                                                    _vm.item.driver2 ===
                                                    _vm.driverTypes.Starts
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("starts")
                                                              ) + " "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("hours")
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm.getValidateObject(
                                                  "p80Limit2"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback d-block",
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "p80Limit2"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-group input-group-sm mb-3",
                                            class: [
                                              {
                                                "col-6":
                                                  !_vm.shouldShowPleLimit(
                                                    _vm.item.kksCode,
                                                    _vm.item.driver2
                                                  ),
                                              },
                                              {
                                                "col-3": _vm.shouldShowPleLimit(
                                                  _vm.item.kksCode,
                                                  _vm.item.driver2
                                                ),
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("tolerance")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.number",
                                                  value: _vm.item.tolerance2,
                                                  expression: "item.tolerance2",
                                                  modifiers: { number: true },
                                                },
                                              ],
                                              class: [
                                                {
                                                  "is-invalid":
                                                    _vm.getValidateObject(
                                                      "tolerance2"
                                                    ) ||
                                                    _vm.isInputInvalid(
                                                      _vm.item.tolerance2,
                                                      _vm.tolerance2ItemChanged,
                                                      3
                                                    ),
                                                },
                                                "form-control",
                                              ],
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                disabled:
                                                  _vm.isItemLinkedWithSupport,
                                              },
                                              domProps: {
                                                value: _vm.item.tolerance2,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.handleToleranceChanged(
                                                    true
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.item,
                                                    "tolerance2",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            _vm._m(30),
                                            _c(
                                              "div",
                                              {
                                                class: {
                                                  "invalid-feedback":
                                                    _vm.getValidateObject(
                                                      "tolerance2"
                                                    ),
                                                },
                                              },
                                              _vm._l(
                                                _vm.getValidateObject(
                                                  "tolerance2"
                                                ),
                                                function (error) {
                                                  return _c("span", [
                                                    _vm._v(_vm._s(error)),
                                                  ])
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("duration"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.item.duration,
                                              expression: "item.duration",
                                              modifiers: { number: true },
                                            },
                                          ],
                                          class: [
                                            {
                                              "is-invalid":
                                                _vm.getValidateObject(
                                                  "duration"
                                                ) ||
                                                _vm.isInputInvalid(
                                                  _vm.item.duration,
                                                  _vm.durationItemChanged,
                                                  4
                                                ),
                                            },
                                            "form-control",
                                          ],
                                          attrs: { type: "number", min: "1" },
                                          domProps: {
                                            value: _vm.item.duration,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleDurationChanged()
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "duration",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "input-group-append" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [_vm._v(_vm._s(_vm.$t("days")))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback":
                                                _vm.getValidateObject(
                                                  "duration"
                                                ),
                                            },
                                          },
                                          _vm._l(
                                            _vm.getValidateObject("duration"),
                                            function (error) {
                                              return _c("span", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "input-group-prepend",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("unitShutdown"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.item.unitShutdown,
                                              expression: "item.unitShutdown",
                                              modifiers: { number: true },
                                            },
                                          ],
                                          class: [
                                            {
                                              "is-invalid":
                                                _vm.getValidateObject(
                                                  "unitShutdown"
                                                ),
                                            },
                                            "form-control",
                                          ],
                                          attrs: { type: "number", min: "0" },
                                          domProps: {
                                            value: _vm.item.unitShutdown,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "unitShutdown",
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "input-group-append" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [_vm._v(_vm._s(_vm.$t("days")))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: {
                                              "invalid-feedback":
                                                _vm.getValidateObject(
                                                  "unitShutdown"
                                                ),
                                            },
                                          },
                                          _vm._l(
                                            _vm.getValidateObject(
                                              "unitShutdown"
                                            ),
                                            function (error) {
                                              return _c("span", [
                                                _vm._v(_vm._s(error)),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-6 mb-3" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "input-group input-group-sm mb-3",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [_vm._v(_vm._s(_vm.$t("cost")))]
                                              ),
                                            ]
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.item.cost,
                                                expression: "item.cost",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            class: [
                                              {
                                                "is-invalid":
                                                  _vm.getValidateObject(
                                                    "cost"
                                                  ) ||
                                                  _vm.isInputInvalid(
                                                    _vm.item.cost,
                                                    _vm.costItemChanged,
                                                    1
                                                  ),
                                              },
                                              "form-control form-control-sm",
                                            ],
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              disabled:
                                                _vm.isPtRiskOrOpportunity(
                                                  _vm.item
                                                ),
                                            },
                                            domProps: { value: _vm.item.cost },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleCostChanged()
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.item,
                                                  "cost",
                                                  _vm._n($event.target.value)
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [
                                                  _vm._v(
                                                    "(K" +
                                                      _vm._s(
                                                        _vm.getCurrencySymbol()
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                "invalid-feedback":
                                                  _vm.getValidateObject("cost"),
                                              },
                                            },
                                            _vm._l(
                                              _vm.getValidateObject("cost"),
                                              function (error) {
                                                return _c("span", [
                                                  _vm._v(_vm._s(error)),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "input-group input-group-sm",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "input-group-prepend",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "showAsMainStrategyItem"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.item
                                                            .showAsMainStrategyItem,
                                                        expression:
                                                          "item.showAsMainStrategyItem",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.item
                                                          .showAsMainStrategyItem
                                                      )
                                                        ? _vm._i(
                                                            _vm.item
                                                              .showAsMainStrategyItem,
                                                            null
                                                          ) > -1
                                                        : _vm.item
                                                            .showAsMainStrategyItem,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.item
                                                              .showAsMainStrategyItem,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.item,
                                                                "showAsMainStrategyItem",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.item,
                                                                "showAsMainStrategyItem",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "showAsMainStrategyItem",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 input-group input-group-sm mb-3",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-group-prepend comment-label",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "input-group-text",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("comment"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.item.comment,
                                              expression: "item.comment",
                                            },
                                          ],
                                          staticClass:
                                            "comment-textarea form-control form-control-sm",
                                          domProps: { value: _vm.item.comment },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.item,
                                                "comment",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              style: {
                                display:
                                  _vm.tabs.planning.active === true
                                    ? "block"
                                    : "none",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-responsive" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table table-sm table-bordered",
                                    attrs: { id: "planning-table" },
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", { staticClass: "text-center" }, [
                                        _c("th", { attrs: { rowspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("globalProjectId")) +
                                              " - " +
                                              _vm._s(_vm.$t("projectName"))
                                          ),
                                        ]),
                                        _c("th", { attrs: { rowspan: "2" } }, [
                                          _vm._v(_vm._s(_vm.$t("date"))),
                                        ]),
                                        _c(
                                          "th",
                                          {
                                            attrs: {
                                              rowspan: "2",
                                              colspan: "4",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("cost")) +
                                                " (K" +
                                                _vm._s(
                                                  _vm.getCurrencySymbol()
                                                ) +
                                                ") "
                                            ),
                                          ]
                                        ),
                                        _c("th", { attrs: { rowspan: "2" } }, [
                                          _vm._v(_vm._s(_vm.$t("duration"))),
                                        ]),
                                        _c("th", { attrs: { rowspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("maintDescription"))
                                          ),
                                        ]),
                                        _c("th", { attrs: { rowspan: "2" } }, [
                                          _vm._v(_vm._s(_vm.$t("outageId"))),
                                        ]),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "leading-item",
                                            attrs: { rowspan: "2" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("leadingItem"))
                                            ),
                                          ]
                                        ),
                                        _c("th", { attrs: { colspan: "2" } }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("outageRiskOfExtension")
                                            )
                                          ),
                                        ]),
                                        _c("th", { attrs: { rowspan: "2" } }),
                                      ]),
                                      _c("tr", { staticClass: "text-center" }, [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("outageExtensionDays")
                                            )
                                          ),
                                        ]),
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "outageExtensionTechnicalProbability"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.planning,
                                          function (planningItem, index) {
                                            return [
                                              _c(
                                                "tr",
                                                {
                                                  class: [
                                                    {
                                                      "new-item":
                                                        planningItem.status ==
                                                        "I",
                                                    },
                                                    {
                                                      "edit-item":
                                                        planningItem.editMode,
                                                    },
                                                  ],
                                                },
                                                [
                                                  _c("td", [
                                                    planningItem.globalId &&
                                                    planningItem.projectName
                                                      ? _c("input", {
                                                          staticClass:
                                                            "form-control form-control-sm",
                                                          attrs: {
                                                            disabled:
                                                              "disabled",
                                                            type: "text",
                                                            title:
                                                              planningItem.globalId +
                                                              " - " +
                                                              planningItem.projectName,
                                                          },
                                                          domProps: {
                                                            value:
                                                              planningItem.globalId +
                                                              " - " +
                                                              planningItem.projectName,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    !planningItem.globalId ||
                                                    !planningItem.projectName
                                                      ? _c("input", {
                                                          staticClass:
                                                            "form-control form-control-sm",
                                                          attrs: {
                                                            disabled:
                                                              "disabled",
                                                            type: "text",
                                                            title:
                                                              _vm.$t(
                                                                "noPmlConnection"
                                                              ),
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.$t(
                                                                "noPmlConnection"
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]),
                                                  _c(
                                                    "td",
                                                    [
                                                      _c("date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          "value-type":
                                                            "format",
                                                          format: "YYYY-MM-DD",
                                                          "input-class": [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "planning[" +
                                                                    index +
                                                                    "].maintenanceDate"
                                                                ) ||
                                                                _vm.isInputInvalid(
                                                                  planningItem.maintenanceDate,
                                                                  planningItem.maintenanceDateChanged
                                                                ),
                                                            },
                                                            "form-control form-control-sm",
                                                          ],
                                                          disabled:
                                                            !planningItem.editMode ||
                                                            planningItem.unitMaintenancePlanningId ||
                                                            _vm.item.driver ===
                                                              _vm.driverTypes
                                                                .Once,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handlePlanningDateItemChanged(
                                                              index
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            planningItem.maintenanceDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              planningItem,
                                                              "maintenanceDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "planningItem.maintenanceDate",
                                                        },
                                                      }),
                                                      _vm.getValidateObject(
                                                        "planning[" +
                                                          index +
                                                          "].maintenanceDate"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback d-block",
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "planning[" +
                                                                  index +
                                                                  "].maintenanceDate"
                                                              ),
                                                              function (error) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        error
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.costTwoYearsPrior,
                                                          expression:
                                                            "planningItem.costTwoYearsPrior",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].costTwoYearsPrior"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        placeholder: "y-2",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.costTwoYearsPrior,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "costTwoYearsPrior",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.costPreviousYear,
                                                          expression:
                                                            "planningItem.costPreviousYear",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].costPreviousYear"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        placeholder: "y-1",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.costPreviousYear,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "costPreviousYear",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].costPreviousYear"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].costPreviousYear"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.cost,
                                                          expression:
                                                            "planningItem.cost",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].cost"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        disabled:
                                                          !planningItem.editMode,
                                                        placeholder: "y",
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.cost,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "cost",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].cost"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].cost"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.costNextYear,
                                                          expression:
                                                            "planningItem.costNextYear",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].costNextYear"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        placeholder: "y+1",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.costNextYear,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "costNextYear",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].costNextYear"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].costNextYear"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.duration,
                                                          expression:
                                                            "planningItem.duration",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].duration"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.duration,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "duration",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].duration"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].duration"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            planningItem.maintenanceDesc,
                                                          expression:
                                                            "planningItem.maintenanceDesc",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.maintenanceDesc,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "maintenanceDesc",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]),
                                                  _c("td", [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              planningItem.unitMaintenancePlanningId,
                                                            expression:
                                                              "planningItem.unitMaintenancePlanningId",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "add-maintenance-item-modal__planning-outage form-control form-control-sm",
                                                        attrs: {
                                                          disabled:
                                                            !planningItem.editMode,
                                                        },
                                                        on: {
                                                          change: [
                                                            function ($event) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.$set(
                                                                planningItem,
                                                                "unitMaintenancePlanningId",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function ($event) {
                                                              return _vm.outageIdChange(
                                                                planningItem
                                                              )
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm.nullValue,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "noOutageLinked"
                                                                )
                                                              ) + " "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._l(
                                                          _vm.outageIds,
                                                          function (outageId) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.isOutageAlreadySelected(
                                                                      outageId
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    outageId.unitMaintenancePlanningId,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      outageId.id
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              planningItem.leadingItem,
                                                            expression:
                                                              "planningItem.leadingItem",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "checkbox",
                                                          disabled:
                                                            !planningItem.editMode,
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              planningItem.leadingItem
                                                            )
                                                              ? _vm._i(
                                                                  planningItem.leadingItem,
                                                                  null
                                                                ) > -1
                                                              : planningItem.leadingItem,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.leadingItemSelected(
                                                              planningItem
                                                            )
                                                          },
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                planningItem.leadingItem,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    planningItem,
                                                                    "leadingItem",
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    planningItem,
                                                                    "leadingItem",
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                planningItem,
                                                                "leadingItem",
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.extensionDays,
                                                          expression:
                                                            "planningItem.extensionDays",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].ExtensionDays"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.extensionDays,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "extensionDays",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].ExtensionDays"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].ExtensionDays"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value:
                                                            planningItem.technicalProbability,
                                                          expression:
                                                            "planningItem.technicalProbability",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control form-control-sm technical-probability",
                                                      class: {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "planning[" +
                                                              index +
                                                              "].TechnicalProbability"
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        max: "100",
                                                        disabled:
                                                          !planningItem.editMode,
                                                      },
                                                      domProps: {
                                                        value:
                                                          planningItem.technicalProbability,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            planningItem,
                                                            "technicalProbability",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        class: {
                                                          "invalid-feedback":
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].TechnicalProbability"
                                                            ),
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.getValidateObject(
                                                          "planning[" +
                                                            index +
                                                            "].TechnicalProbability"
                                                        ),
                                                        function (error) {
                                                          return _c("span", [
                                                            _vm._v(
                                                              _vm._s(error)
                                                            ),
                                                          ])
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        "white-space": "nowrap",
                                                        "min-width": "60px",
                                                      },
                                                    },
                                                    [
                                                      planningItem.editMode
                                                        ? _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "ok-item-button align-middle",
                                                              attrs: {
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                viewBox:
                                                                  "0 0 512 512",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.closeEdit(
                                                                      planningItem
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      !planningItem.editMode
                                                        ? _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "edit-item-button align-middle",
                                                              attrs: {
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                viewBox:
                                                                  "0 0 576 512",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openEdit(
                                                                      _vm.planning,
                                                                      planningItem
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d: "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      !planningItem.editMode
                                                        ? _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "delete-item-button align-middle",
                                                              attrs: {
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                viewBox:
                                                                  "0 0 448 512",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteItem(
                                                                      _vm.planning,
                                                                      planningItem
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d: "M192 188v216c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12V188c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12zm100-12h-24c-6.627 0-12 5.373-12 12v216c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V188c0-6.627-5.373-12-12-12zm132-96c13.255 0 24 10.745 24 24v12c0 6.627-5.373 12-12 12h-20v336c0 26.51-21.49 48-48 48H80c-26.51 0-48-21.49-48-48V128H12c-6.627 0-12-5.373-12-12v-12c0-13.255 10.745-24 24-24h74.411l34.018-56.696A48 48 0 0 1 173.589 0h100.823a48 48 0 0 1 41.16 23.304L349.589 80H424zm-269.611 0h139.223L276.16 50.913A6 6 0 0 0 271.015 48h-94.028a6 6 0 0 0-5.145 2.913L154.389 80zM368 128H80v330a6 6 0 0 0 6 6h276a6 6 0 0 0 6-6V128z",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.getValidateObject(
                                                "planning[" +
                                                  index +
                                                  "].LeadingItem"
                                              )
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        attrs: {
                                                          colspan: "13",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          _vm._l(
                                                            _vm.getValidateObject(
                                                              "planning[" +
                                                                index +
                                                                "].LeadingItem"
                                                            ),
                                                            function (error) {
                                                              return _c(
                                                                "span",
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      error
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _c("tfoot", [
                                      _vm.isPtRiskOrOpportunity(_vm.item) &&
                                      _vm.planning.length > 0
                                        ? _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "13" } },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "disable-pt-risk",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "disablePtRiskConnection"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.item
                                                              .disablePtRiskConnection,
                                                          expression:
                                                            "item.disablePtRiskConnection",
                                                        },
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        disabled:
                                                          !_vm.anyPlanningItemInEditMode(),
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.item
                                                            .disablePtRiskConnection
                                                        )
                                                          ? _vm._i(
                                                              _vm.item
                                                                .disablePtRiskConnection,
                                                              null
                                                            ) > -1
                                                          : _vm.item
                                                              .disablePtRiskConnection,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.item
                                                                .disablePtRiskConnection,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.item,
                                                                  "disablePtRiskConnection",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.item,
                                                                  "disablePtRiskConnection",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.item,
                                                              "disablePtRiskConnection",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c("tr", [
                                        _c("td", { attrs: { colspan: "13" } }, [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "add-item-button mt-2",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addPlanning()
                                                },
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm.getValidateObject("planning") || _vm.errorMessage
                            ? _c("div", { staticClass: "my-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 alert alert-danger show",
                                  },
                                  [
                                    _vm.errorMessage
                                      ? _c("span", [
                                          _vm._v(
                                            " " + _vm._s(_vm.errorMessage) + " "
                                          ),
                                        ])
                                      : _vm._l(
                                          _vm.getValidateObject("planning"),
                                          function (error) {
                                            return _c("span", [
                                              _vm._v(_vm._s(error)),
                                            ])
                                          }
                                        ),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                          _vm.showResultBox === true
                            ? _c("div", { staticClass: "row my-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 alert alert-dismissible fade",
                                    class: {
                                      show: _vm.showResultBox,
                                      "alert-success": !_vm.resultError,
                                      "alert-danger": _vm.resultError,
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.result) + " ")]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.item.plantItemMaintenanceId > 0 &&
                  _vm.tabs.item.active === true
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm btn-primary copy-maintenance-btn",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.initMaintenanceCopy()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("copyMaintenance")) + " ")]
                      )
                    : _vm._e(),
                  _vm.item !== null &&
                  _vm.item.plantItemMaintenanceId > 0 &&
                  _vm.tabs.item.active === true
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm delete-button",
                          attrs: {
                            type: "button",
                            disabled:
                              !_vm.userHasWriteAccess || _vm.waitingForSave,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.confirmDeleteMaintenance()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "wait",
                      class: { "fade-in": _vm.waitingForSave === true },
                    },
                    [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: {
                        type: "button",
                        disabled: _vm.waitingForSave,
                        "data-dismiss": "modal",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        type: "button",
                        id: "savePlantMaintenanceItemButton",
                        disabled: !_vm.userHasWriteAccess || _vm.waitingForSave,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveChanges(_vm.item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("saveChanges")) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("confirm-snackbar", {
        attrs: {
          open: _vm.confirmSnackbarOpen,
          "callback-function": _vm.cancel,
          message: _vm.$t("unsavedChanges"),
        },
      }),
      _c("confirm-snackbar", {
        attrs: {
          open: _vm.deleteSnackbarOpen,
          "callback-function": _vm.deleteMaintenance,
          message: _vm.$t("confirmDelete"),
        },
      }),
      _c(
        "pui-lightbox",
        {
          ref: _vm.keepUelValueModalRef,
          attrs: {
            "fit-content": true,
            "default-footer-confirm-label": _vm.$t("yes"),
            "default-footer-cancel-label": _vm.$t("no"),
            "on-cancel-callback": _vm.overwriteUELValue,
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("uelKeepCurrentValue")) + " ")]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "copyMaintenanceModal", tabindex: "-1", role: "dialog" },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("copyMaintenance")))]),
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm col-12 mb-3" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("maintDescription")) + ":"),
                          ]),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.maintenanceCopyData.maintenanceDescription,
                              expression:
                                "maintenanceCopyData.maintenanceDescription",
                            },
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid":
                              !_vm.maintenanceCopyData
                                .maintenanceDescriptionValid,
                          },
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t("maintDescription"),
                          },
                          domProps: {
                            value:
                              _vm.maintenanceCopyData.maintenanceDescription,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.maintenanceCopyData,
                                "maintenanceDescription",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm col-12 mb-3" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("plantArea")) + ":"),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.maintenanceCopyData.selectedArea,
                                expression: "maintenanceCopyData.selectedArea",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": !_vm.maintenanceCopyData.areaValid,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.maintenanceCopyData,
                                    "selectedArea",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function ($event) {
                                  return _vm.areaChange(
                                    _vm.maintenanceCopyData.selectedArea
                                  )
                                },
                              ],
                            },
                          },
                          _vm._l(
                            _vm.maintenanceCopyData.areas,
                            function (area) {
                              return _c(
                                "option",
                                { domProps: { value: area.name } },
                                [_vm._v(" " + _vm._s(area.name) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "input-group input-group-sm col-12" },
                      [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.$t("plantItem")) + ":"),
                          ]),
                        ]),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.maintenanceCopyData.selectedPlantItemId,
                                expression:
                                  "maintenanceCopyData.selectedPlantItemId",
                              },
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid":
                                !_vm.maintenanceCopyData.plantItemIdValid,
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.maintenanceCopyData,
                                  "selectedPlantItemId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          _vm._l(
                            _vm.maintenanceCopyData.plantItemSelection,
                            function (item) {
                              return _c(
                                "option",
                                { domProps: { value: item.id } },
                                [_vm._v(" " + _vm._s(item.name) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.maintenanceCopyData.inProgress
                    ? _c("span", [_vm._v(_vm._s(_vm.$t("pleaseWait")))])
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: {
                        type: "button",
                        disabled: _vm.maintenanceCopyData.inProgress,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.cancelCopy()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.copyMaintenance()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("copy")) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "categoryChangeConfirmationModal",
            tabindex: "-1",
            role: "dialog",
            "data-keyboard": "false",
            "data-backdrop": "false",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header p-3" }, [
                  _c("h5", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.$t("confirmModalTitle"))),
                  ]),
                ]),
                _c("div", { staticClass: "modal-body p-3" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("maintenanceCategoryChangeConfirmationMessage")
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "modal-footer p-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelCategoryChange()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmCategoryChange()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [_c("span", [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("S")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("MVA")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("DtDr")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("OHr")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K2")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K3")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Ez")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("En")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Ks")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K2")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K3")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("S")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("MVA")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("DtDr")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("OHr")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K2")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K3")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Ez")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("En")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("Ks")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K2")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("K3")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("div", { staticClass: "input-group-text" }, [_vm._v("%")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }